import {
  StyledDownward,
  StyledSelectBox,
  StyledSelectBoxContainer,
  StyledSelectBoxProps,
} from "components/parts/Input/SelectBox/styled";
import React from "react";

export type PresenterProps = {
  name?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  value?: string | number;
  optionList: Option[];
  onBlur?: React.FocusEventHandler<HTMLSelectElement> | undefined;
  onChange: React.ChangeEventHandler<HTMLSelectElement>;
} & StyledSelectBoxProps;

export type Option = {
  value: string | number;
  text: string;
  optional?: string;
};

export const SelectBoxPresenter: React.FC<PresenterProps> = ({
  value,
  optionList,
  onChange,
  ...rest
}) => {
  return (
    <StyledSelectBoxContainer>
      <StyledSelectBox {...rest} value={value} onChange={onChange}>
        {optionList.map((option) => (
          <option key={option.value} value={option.value}>
            {option.text}
          </option>
        ))}
      </StyledSelectBox>
      <StyledDownward />
    </StyledSelectBoxContainer>
  );
};
